import { Card, Checkbox, Col, Collapse, Divider, Form, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { ListWrapper } from './styles';
import { useDispatch, useSelector } from '@redux';
import { getAllRolePermissionGroups } from '@redux/rolePermissionGroups/actions';
import crudSelectors from '@redux/crudSelectors';
import { DynamicObjectType } from 'types/commons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/pro-light-svg-icons';
import { useRestContext } from 'components/form/RestInputContext';
import FormItem from 'components/form/FormItem';

const { Panel } = Collapse;

function CustomPanelHeader({ title, isActive, onClick, hasIcon }) {
  return (
    <Divider orientation="left" orientationMargin={0} className="text-sm">
      <div className="d-flex">
        {hasIcon && (
          <div onClick={onClick}>
            <span className={isActive ? 'icon-panel rotated' : 'icon-panel'}>
              {isActive ? (
                <FontAwesomeIcon icon={faMinus} />
              ) : (
                <FontAwesomeIcon icon={faPlus} />
              )}
            </span>
          </div>
        )}
        <div className="text-title-gray text-sm">{title}</div>
      </div>
    </Divider>
  );
}

const PermissionsList = () => {
  const dispatch = useDispatch();
  const { form } = useRestContext();

  const dataPermissions = useSelector<DynamicObjectType[]>(
    crudSelectors.rolePermissionGroups.getDataRecordArr,
  );

  const [activePanel, setActivePanel] = useState(null);

  const handlePanelChange = (key) => {
    setActivePanel(activePanel === key ? null : key);
  };

  useEffect(() => {
    dispatch(
      getAllRolePermissionGroups({
        data: {
          page: 1,
          pageSize: 100,
          orderBy: ['priority,ASC', 'subRolePermissionGroups.priority,ASC'],
        },
        options: {},
      }),
    );
  }, [form]);

  const handleSelectAll = (checked, subItem) => {
    if (checked) {
      form.setFieldsValue({
        rolePermissions: {
          ...form.getFieldValue('rolePermissions'),
          [subItem?.id]: subItem?.rolePermissions?.map((item) => item?.id),
        },
      });
    } else {
      form.setFieldsValue({
        rolePermissions: {
          ...form.getFieldValue('rolePermissions'),
          [subItem?.id]: [],
        },
      });
    }
  };

  return (
    <ListWrapper>
      <Card>
        <Row gutter={[20, 20]}>
          <Col span={12}>
            <div className="text-title-gray fw-600" style={{ paddingLeft: 16 }}>
              Permissions
            </div>
          </Col>
        </Row>
        <br />
        {dataPermissions?.map((item: DynamicObjectType) => {
          return (
            <div key={item?.id}>
              <div className="list-permissions-title text-title-gray fw-600">
                {item?.name}
              </div>
              <Collapse
                ghost
                expandIcon={() => null}
                activeKey={activePanel}
                collapsible="icon"
                onChange={handlePanelChange}
              >
                {item?.subRolePermissionGroups?.map(
                  (subItem: DynamicObjectType) => {
                    return (
                      <Panel
                        header={
                          <div className="d-flex flex-center-between">
                            <CustomPanelHeader
                              title={subItem?.name}
                              isActive={activePanel === subItem?.id}
                              onClick={() =>
                                setActivePanel(
                                  activePanel === subItem?.id
                                    ? null
                                    : subItem?.id,
                                )
                              }
                              hasIcon={subItem?.rolePermissions?.length > 0}
                            />
                            {subItem?.rolePermissions?.length > 0 && (
                              <Form.Item shouldUpdate noStyle>
                                {({ getFieldValue }) => {
                                  const checked =
                                    getFieldValue('rolePermissions')?.[
                                      subItem?.id
                                    ];

                                  const total =
                                    subItem?.rolePermissions?.length;

                                  return (
                                    <Checkbox
                                      className="ml-5"
                                      onChange={(e) => {
                                        setActivePanel(subItem?.id);
                                        handleSelectAll(
                                          e?.target?.checked,
                                          subItem,
                                        );
                                      }}
                                      indeterminate={
                                        checked?.length > 0 &&
                                        checked?.length < total
                                      }
                                      checked={checked?.length === total}
                                    />
                                  );
                                }}
                              </Form.Item>
                            )}
                          </div>
                        }
                        key={subItem?.id}
                      >
                        {subItem?.rolePermissions?.length > 0 && (
                          <FormItem
                            name={['rolePermissions', subItem?.id]}
                            noStyle
                          >
                            <Checkbox.Group style={{ width: '100%' }}>
                              <Row gutter={[0, 0]}>
                                {subItem?.rolePermissions?.map(
                                  (role: DynamicObjectType) => {
                                    return (
                                      <Col span={12} key={role?.id}>
                                        <div className="list-permissions-panel-item">
                                          <Checkbox value={role?.id}>
                                            <span style={{ marginLeft: 60 }}>
                                              {role?.name}
                                            </span>
                                          </Checkbox>
                                        </div>
                                      </Col>
                                    );
                                  },
                                )}
                              </Row>
                            </Checkbox.Group>
                          </FormItem>
                        )}
                      </Panel>
                    );
                  },
                )}
              </Collapse>
            </div>
          );
        })}
      </Card>
    </ListWrapper>
  );
};

export default PermissionsList;
